skrilla.directive('queryBetsForReporting', function ($window, betService) {
    return {
        templateUrl: 'directives/queryBets/queryBetsForReporting.html',
        scope: {
            key: "=",
            queryKey: "=",
            userId: "=",
            marketId: "=",
            subtitle: "=",
            currency: "="
        },
        controller: async function ($scope,
                                    searchService,
                                    queryService,
                                    paginationService,
                                    cacheService,
                                    sportService,
                                    currencyService,
                                    constantsService,
                                    $location) {
            $scope.key = "queryBetsForReporting"
            $scope.queryKey = "queryBetsForReportingQueryKey"
            let eventIds = $location.search().eventIds;
            $scope.eventIdsText = typeof  eventIds === 'object' ? eventIds?.join(", ") : eventIds;
            $scope.sports = await sportService.getSports();
            $scope.currencies = currencyService.getCurrencies();
            $scope.productFeeTags = await searchService.get("betting/events/productFeeTagTypes").then(function(response){
                var subs = [];
                $scope.tags = response.data;
                $scope.parentToChildren = response.data;
                $scope.tags.forEach(function(tag){
                    subs = subs.concat(tag.second);
                });
                $scope.tags = $scope.tags.filter(function(tag){
                    return !subs.includes(tag.first);
                })
                cacheService.registerObject("productFeeTags", response.data);
                return $scope.tags;
            });
            $scope.sortBy = {
                CREATED_AT: 'Created At',
                UPDATED_AT: 'Updated At',
                PAID_OUT: 'Paid out',
                POTENTIAL_PAYOUT: 'Potential Payout',
                STAKE: 'Stake'
            }
            $scope.totalBets = 0
            $scope.betLimit = 300000

            $scope.reset = function () {
                $scope.query = {
                    limit: 20,
                    sport: null,
                    productFeeTag: null,
                    statuses: {
                        CREATED: true,
                        ACCEPTED: true,
                        LIVE: true,
                        REJECTED: !$scope.marketId,  //todd doesn't want rejected bets in market bet page,
                        SETTLED: true,
                        CANCELLED: true,
                        VOID: true
                    },
                    results: {
                        UNDECIDED: true,
                        WIN: true,
                        LOSE: true,
                        VOID: true
                    },
                    sortOrder: 'DESC'
                };
                $scope.loading = false;
            };
            $scope.query = cacheService.getObject($scope.queryKey)
            $scope.reset()


            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getBets, $scope.key);
            }

            function queryParams() {
                let eventIds  = [];
                let eventIdsText = $scope.eventIdsText;
                if (eventIdsText) {
                    //split on anything that isn't part of a UUID
                    eventIds = eventIdsText.split(/[^a-f0-9-]{1,}/g).map((it) => it.trim())
                }

                const query = {
                    ...$scope.query,
                    minimumPayout: $scope.query.minimumPayout ? $scope.query.minimumPayout * 100 : null,
                    maximumPayout: $scope.query.maximumPayout ? $scope.query.maximumPayout * 100 : null,
                    minimumWinnings: $scope.query.minimumWinnings ? $scope.query.minimumWinnings * 100 : null,
                    maximumWinnings: $scope.query.maximumWinnings ? $scope.query.maximumWinnings * 100 : null,
                    minimumStake: $scope.query.minimumStake ? $scope.query.minimumStake * 100 : null,
                    maximumStake: $scope.query.maximumStake ? $scope.query.maximumStake * 100 : null,
                    eventIds

                };
                query.marketId = $scope.marketId
                cacheService.registerObject($scope.queryKey, $scope.query)
                const queryParams = queryService.getQueryString(query, $scope.key);
                return queryParams;
            }


            var getBets = function () {
                $scope.loading = true
                return searchService.get("bets/reportingCsv" + queryParams(), true, true)
                    .then(res => {
                        const blob = new Blob([res.data], {type: 'text/plain'});
                        const file = $window.URL.createObjectURL(blob);
                        const tempLink = $window.document.createElement('a');
                        tempLink.style.display = 'none';
                        tempLink.href = file;
                        const filename = "audit.csv";
                        tempLink.setAttribute('download', filename);

                        $window.document.body.appendChild(tempLink);
                        tempLink.click();
                        $window.document.body.removeChild(tempLink);

                        return file
                    }).finally(file => {
                        $window.URL.revokeObjectURL(file)
                        $scope.loading = false
                    })
            }


            $scope.exportCsv = function () {
                $scope.downloadingCsv = true;

                searchService.get("bets/export" + queryParams())
                    .then(res => {
                        console.log("doin shit")
                        const blob = new Blob([res.data], {type: 'text/plain'});
                        const file = $window.URL.createObjectURL(blob);
                        const tempLink = $window.document.createElement('a');
                        tempLink.style.display = 'none';
                        tempLink.href = file;
                        const filename =$scope.exportFilename + ($scope.exportFilename.endsWith(".csv") ? "": ".csv");
                        tempLink.setAttribute('download', filename);

                        $window.document.body.appendChild(tempLink);
                        tempLink.click();
                        $window.document.body.removeChild(tempLink);

                        return file
                    }).finally(file => {
                    $window.URL.revokeObjectURL(file)
                    $scope.downloadingCsv = false
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
